import {
  observable, computed, action,
} from 'mobx';
import ProductsService from 'services/Products.service';
import arrangeKenticoStructure from 'services/KenticoStructureParser';

class ProductsStore {
  @observable currentProduct = {};

  @observable loadingCurrentProduct = true;

  @observable cachedProducts = [];

  constructor(coreStore) {
    this.coreStore = coreStore;
  }

  @computed
  get parsedStructure() {
    return arrangeKenticoStructure(this.currentProduct);
  }

  @action
  async setCurrentProductByUrlSlug(urlSlug) {
    const slug = `/${urlSlug || ''}`;
    const cachedProduct = this.cachedProducts.find(product => product.slug === slug);

    if (cachedProduct) {
      this.currentProduct = cachedProduct;
    } else {
      this.loadingCurrentProduct = true;
      const fetchedProduct = await ProductsService.fetchProductByUrlSlug(slug);
      this.loadingCurrentProduct = false;
      if (!fetchedProduct) {
        this.currentProduct = null;
        return;
      }
      this.currentProduct = fetchedProduct;
      this.cachedProducts.push(fetchedProduct);
    }
  }
}

export default ProductsStore;



// WEBPACK FOOTER //
// ./src/stores/Products.store.js